import { Component } from '@angular/core';
import { StripMarginService } from 'src/app/modules/shared/_services/strip-margin.service';
import { SharedService } from 'src/app/modules/shared/_services/shared.service';
import { AlertMessageService } from 'src/app/modules/shared/_services/alert-message.service';
import { MetaService } from 'src/app/_configs/meta.service';
import { AuthService } from 'src/app/modules/auth/_services/auth.service';

@Component({
  selector: 'app-download-tender-mobile-app',
  templateUrl: './download-tender-mobile-app.component.html',
  styleUrls: ['./download-tender-mobile-app.component.scss']
})
export class LandingPageComponent {
  stripMargin: boolean = true;
  mobileNumber: any;
  isSignupButtonEnabled: boolean = false;
  successfullShow = false;
  daysLeft: number = 0;
  shouldShowTrialBanner: boolean = false;

  constructor(private stripMarginService: StripMarginService,
    private sharedService: SharedService, private metaService: MetaService,
    private alertService: AlertMessageService,
    private authService: AuthService
  ) { }

  ngOnInit() {
    this.stripMarginService.stripMargin$.subscribe(
      (value) => {
        this.stripMargin = value;
      }
    );
    this.setMetaTags();
    this.checkTrialBanner();
  }

  private setMetaTags(): void {
    const title = "Download TenderShark Mobile App for Finding E-Procurement & Real-Time Tender Updates";
    const description = "Install the TenderShark mobile app from the Play Store for easy access to Indian tenders. Download now on your Android mobile for real-time updates & e-tender tracking.";
    this.metaService.setMetaTags(title, description);
  }

  sendLink() {
    if (this.mobileNumber) {
      this.sharedService.appDownloadLink(this.mobileNumber).subscribe(
        (res: any) => {
          if (res?.code === 200) {
            this.successfullShow = true;
            this.alertService.addSuccess(' App link sent successfully to your mentioned mobile number').show();
          }
        },
        (error: any) => {
          // this.errorMessage = "OTP limit reached. Please try again in 15 minutes.";
        }
      );
    }
  }

  isNumeric(value: string): boolean {
    return /^[0-9]*$/.test(value);
  }

  onInputChange(): void {
    // Check if mobileNumber has exactly 10 characters and is numeric
    this.isSignupButtonEnabled = this.mobileNumber?.length === 10 && this.isNumeric(this.mobileNumber);
  }

  // Restrict non-numeric input
  restrictNonNumeric(event: KeyboardEvent): void {
    const key = event.key;
    if (!/^[0-9]$/.test(key)) {
      event.preventDefault();
    }
  }

  async checkTrialBanner() {
    const { show } = await this.authService.shouldShowTrialBanner();
    this.shouldShowTrialBanner = show;
  }
}
